import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { theme, SIZES, getPixelsFromSize } from '../../../style'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: ${({ row, pixels }) => (row ? 'auto' : `${pixels}px`)};
  width: ${({ row, pixels }) => (!row ? 'auto' : `${pixels}px`)};
  background-color: ${theme.transparent};
  border: ${({ border }) => (border ? `1px solid ${theme.red}` : null)};
`

const Spacer = ({
    row,
    size,
    border,
}) => {
    const pixels = getPixelsFromSize(size)

    return (
        <Container
            row={row}
            pixels={pixels}
            border={border}
        />
    )
}

Spacer.sizes = Object.values(SIZES)

Spacer.propTypes = {
    row: PropTypes.bool,
    size: PropTypes.oneOf(Object.values(SIZES)),
    border: PropTypes.bool,
}

Spacer.defaultProps = {
    row: false,
    size: SIZES.M,
    border: false,
}

export default Spacer
